module.exports = __webpack_public_path__ + "static/img/footer_icon_wechat.fe54753.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer_icon_wechat.png
// module id = bkyE
// module chunks = 29